import { CompanyBranchPage } from "@/features/company/pages/CompanyBranch";

const CompanyBranch = () => {
  return <CompanyBranchPage />;
};

export default CompanyBranch;
